import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { TID } from "../../lib/testIds";

export const GalleryCard = ({ structure, index, onClick }) => {
  const displayIdx = String(index + 1).padStart(2, "0");
  return (
    <motion.button
      layout
      onClick={onClick}
      data-testid={TID.gallery.card(index)}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.5, delay: index * 0.03, ease: "easeOut" }}
      className="group text-left bg-white rounded-2xl border border-slate-200 overflow-hidden cursor-pointer transition-shadow duration-300 hover:shadow-lg hover:shadow-slate-300/40 hover:border-slate-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0A2540] focus-visible:ring-offset-2"
    >
      {/* Image */}
      <div className="relative aspect-[4/3] bg-slate-100 overflow-hidden">
        <img
          src={structure.image_url}
          alt={structure.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />

        {/* Category badge */}
        <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-white/95 backdrop-blur px-2.5 py-1 rounded-full text-[10px] font-mono uppercase tracking-[0.15em] text-slate-800 shadow-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-[#0A2540]" />
          {structure.category}
        </div>

        {/* Number badge */}
        <div className="absolute top-4 right-4 font-display font-semibold text-white text-lg leading-none px-2 py-1 rounded-md bg-slate-900/40 backdrop-blur">
          {displayIdx}
        </div>

        {/* Hover reveal */}
        <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="inline-flex items-center gap-1.5 bg-[#0A2540] text-white text-xs font-semibold px-3 py-1.5 rounded-full">
            View render
            <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={2.5} />
          </div>
        </div>
      </div>

      {/* Meta */}
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-display font-semibold text-lg text-[#0A2540] leading-tight transition-colors">
            {structure.title}
          </h3>
        </div>
        <div className="mt-2 flex items-center gap-2 text-xs text-slate-500 font-mono uppercase tracking-wider">
          <span className="w-6 h-px bg-slate-300" />
          {structure.tag}
        </div>
      </div>
    </motion.button>
  );
};
